/** 紙の書式の基本の型（paper.ts と paperLayout.ts の両方が使う。循環しないよう別ファイル） */
import { z } from "zod";

/** 書式を持つ帳票：見積書・請求書（044）・領収書（046）・{order}（#233 2d。{orderAck}は{order}の書式の部品「請書の欄」で描く） */
export const PaperKind = z.enum(["quote", "invoice", "receipt", "order"]);
/** 帳票の名前（{order}は会社の言葉＝画面は t() を通す） */
export const PAPER_KIND_NAME: Record<"quote" | "invoice" | "receipt" | "order", string> = { quote: "見積書", invoice: "請求書", receipt: "領収書", order: "{order}" };
export type PaperKind = z.infer<typeof PaperKind>;

export const PaperOrient = z.enum(["portrait", "landscape"]);
export type PaperOrient = z.infer<typeof PaperOrient>;
